// extracted by mini-css-extract-plugin
export default {"employee":"absence-import_employee__Uj0FH","elipsis":"absence-import_elipsis__yvWoS","date":"absence-import_date__y7X+P"};